import React from "react";
import AreaReport from "./AreaReport"; // ✅ Import reusable component


const ClimateCulture = () => <AreaReport areaKey="climate_and_culture" color="#457b9d" />; // ✅ Use same color as Input
export default ClimateCulture;